// extracted by mini-css-extract-plugin
export default {"tableHeader":"RevenueByServicesTable_tableHeader__sMzQf"};